const API_URL: string = '/console/api/sync';
const Link_API_URL: string = '/console/linkapi/sync';
const INTERNAL_API_URL: string = '/internal/console/api/sync';
const CONFIG_URL: string = '/console/config';
const USERS_API_URL: string = '/console/users';
const STARGATE_API_URL: string = '/console/portal/api';
const FORMS_API_URL: string = '/console/sync/forms';

export class RestApiModel {
  public static PROXY_API_URL: string = API_URL;
  public static PROXY_Link_API_URL: string = Link_API_URL;
  public static PROXY_INTERNAL_API_URL: string = INTERNAL_API_URL;
  public static PROXY_CONFIG_URL: string = CONFIG_URL;
  public static USERS_API_URL: string = USERS_API_URL;
  public static FORMS_API_URL: string = FORMS_API_URL;
  public static STARGATE_API_URL: string = STARGATE_API_URL;
}
